// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Col, Loader, Row } from "@crehana/ui";
import { useStudyPlanTranslation } from "../hooks";
import MetricsCard from "./MetricsCard";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MetricsSkeleton = function MetricsSkeleton(_ref) {
  var fromHomeUser = _ref.fromHomeUser,
    isDark = _ref.isDark,
    dataTestId = _ref['data-testid'];
  var _useStudyPlanTranslat = useStudyPlanTranslation(),
    t = _useStudyPlanTranslat.t;
  return /*#__PURE__*/_jsxs(Row, {
    gutter: fromHomeUser ? 24 : {
      xs: 24,
      lg: 16
    },
    "data-testid": dataTestId,
    children: [/*#__PURE__*/_jsx(Col, {
      xs: 12,
      lg: 6,
      children: /*#__PURE__*/_jsxs(MetricsCard, {
        isDark: isDark,
        children: [/*#__PURE__*/_jsx("h3", {
          className: "font-subtitle3 flex-shrink-0",
          children: t('ACTIVITY_TITLE')
        }), /*#__PURE__*/_jsx("div", {
          className: "h-full flex items-center justify-center",
          children: /*#__PURE__*/_jsx(Loader, {
            white: isDark
          })
        })]
      })
    }), /*#__PURE__*/_jsx(Col, {
      xs: 12,
      lg: 6,
      children: /*#__PURE__*/_jsxs(MetricsCard, {
        isDark: isDark,
        children: [/*#__PURE__*/_jsx("h3", {
          className: "font-subtitle3 flex-shrink-0",
          children: t('PROGRESS_TITLE')
        }), /*#__PURE__*/_jsx("div", {
          className: "h-full flex items-center justify-center",
          children: /*#__PURE__*/_jsx(Loader, {
            white: isDark
          })
        })]
      })
    })]
  });
};
export default MetricsSkeleton;